export const floatNumbersRegexPattern = '^(0$|-?[1-9]\\d*([.]\\d*[0-9]$)?|-?0[.,]\\d*[0-9])$';
export const hasDataRegexRegexPattern = '^[-\\/]{1}$';
export const dataValueRegexPattern = `${floatNumbersRegexPattern}|${hasDataRegexRegexPattern}`;

export const HEIGHT = 38;

export const INPUT_VALUE_TYPE = {
  list: 'LIST',
  date: 'DATE',
  regex: 'REGEX',
};
export const onEnterBlur = (e) => e.key === 'Enter' && e.target.blur();
